import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
export default class Button extends Component {
    disabled = false;
    initialized() {
        super.initialized();
        this.disabled = this.el.hasAttribute('disabled');
    }
    bindEvents(add) {
        const method = bindMethod(add);
        this.el[method]('click', this.onClick);
    }
    onClick = (e) => {
        if (this.disabled) {
            e.preventDefault();
            return;
        }
        this.emit('click');
    };
}
